import React from 'react';

import { useApolloClient } from '@apollo/client';
import { useStoreContext } from 'features/store';
import { View } from 'react-native';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import useEffectOnce from 'hooks/use-effect-once';
import { useDismissAllAndNavigate } from 'navigation/hooks/use-dismiss-and-navigate';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { useAuthContext } from 'state/auth';
import { useInRestaurantRedemptionContext } from 'state/loyalty/in-restaurant-redemption';
import { useServiceModeContext } from 'state/service-mode';
import { routes } from 'utils/routing';

function SignOut() {
  const client = useApolloClient();
  const { resetStore } = useStoreContext();
  const { setServiceMode } = useServiceModeContext();
  const { resetInRestaurantRedemption } = useInRestaurantRedemptionContext();
  const { setOriginLocation, signOut } = useAuthContext();

  const dismissAndNavigate = useDismissAllAndNavigate();

  useRumPageView('sign-out', 'Sign Out');

  useEffectOnce(() => {
    signOut().finally(() => {
      resetStore();
      resetInRestaurantRedemption();
      setServiceMode(null);
      setOriginLocation(null);
      client.resetStore();
      dismissAndNavigate(routes.base);
    });
  });

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoyaltyLoader />
    </View>
  );
}

export default SignOut;
